import { useMemo } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';

import { CheckTaskType } from '../routes';

import {
  taskToTaskType,
  taskToTaskTypeTaskFragment,
} from './CheckTask/taskToTaskType';

export { taskToTaskTypeTaskFragment };

export function useDefaultTaskType(
  taskType: CheckTaskType | undefined,
  tasks:
    | undefined
    | Array<
        {
          status: GraphQLTypes.CheckWorkflowTaskStatus;
        } & GraphQLTypes.taskToTaskTypeTaskFragment
      >,
) {
  return useMemo(() => {
    if (taskType) {
      return taskType;
    } else if (isMinLengthArray(1, tasks)) {
      const task =
        tasks.find(
          ({ status }) =>
            status === GraphQLTypes.CheckWorkflowTaskStatus.FAILED,
        ) ?? tasks[0];
      return taskToTaskType(task);
    } else {
      return 'unknown';
    }
  }, [taskType, tasks]);
}
